import Component from '@glimmer/component';

export default class MwQuestProfileStatus extends Component {}